import React, { Component } from "react"
import "./Index.scss"
import DataHeader from "./containers/DataHeader"
import DataTable from "./containers/DataTable"
import dataIcon from "app/styles/images/sp/data-selected.svg"
import { observer, inject } from "mobx-react"
import Store from "app/stores/pgd/dataManage"

@inject("pgdDataManage") @observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }

  render() {
    return (
      <div className="datamanage-page pgd">
        <h2 className="page-title"><img alt="" src={dataIcon} />数据管理</h2>
        <div className="clearfix wrapper-box-first">
          <DataHeader store={this.store} />
        </div>
        <div>
          <DataTable store={this.store} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/data_manage/index.js